import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { httpRequest } from '../services/httpService';
import { useSnackbar } from "../contexts/SnackbarContext";
import { EmptyGuid } from '../utils/constants';

export function useForm({ id, fetchUrl, saveUrl, validate, afterLoad }) {
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
    const [created, setCreated] = useState(false);
    const showSnackbar = useSnackbar();
    const navigate = useNavigate();
    const location = useLocation();

    const isNew = id === EmptyGuid;

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await httpRequest(fetchUrl, {}, showSnackbar);

                let modifiedData = response;
                if (afterLoad) {
                    modifiedData = await afterLoad(response); // Allow afterLoad to modify the data
                }
                setData(modifiedData); // Set the modified data
            } catch (err) {
                setError('Error al obtener los datos');
            } finally {
                setIsLoading(false);
            }
        };

        if (fetchUrl) {
            fetchData();
        }
    }, [fetchUrl]); // Keep afterLoad out of the dependency array to avoid unnecessary re-renders

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));

        // Clear the validation error for the specific field
        setValidationErrors((prev) => {
            const { [name]: _, ...rest } = prev;
            return rest;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate ? validate(data) : {};
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            // Show validation error in snackbar
            showSnackbar({
                message: 'Por favor corrige los errores del formulario',
                severity: 'error'
            });
            return;
        }

        try {
            const savedId = await httpRequest(saveUrl, {
                method: 'POST',
                body: data,
            }, showSnackbar, 'Guardando');
            if (isNew) {
                setCreated(isNew);
                // Universal redirect: replace EmptyGuid in current path with new id
                const newPath = location.pathname.replace(EmptyGuid, savedId);
                navigate(newPath);
            }
        } catch (err) {
            // Handle save error
        }
    };

    const close = () => {
        navigate(created ? -2 : -1);
    };

    return {
        data,
        isLoading,
        error,
        validationErrors,
        handleInputChange,
        handleSubmit,
        isNew,
        close,
    };
}

